import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
} from '@angular/core';
import { MoneyPot } from '@api/models/money-pot.entity';
import { User } from '@api/models/user.entity';

@Component({
	selector: 'plc-money-pot-card',
	templateUrl: './money-pot-card.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoneyPotCardComponent {
	public moneyPot = input.required<MoneyPot>();
	public owners = computed(() => this.moneyPot().owners as User[]);
}
